var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPanelistas(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 187.1 187.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#221e20;}.cls-2{fill:url(#Degradado_sin_nombre_14);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_14",
    x1: 0,
    y1: 93.55,
    x2: 187.1,
    y2: 93.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#28aae1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006496"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M93.55,187.1C41.97,187.1,0,145.14,0,93.55S41.97,0,93.55,0s93.55,41.97,93.55,93.55-41.97,93.55-93.55,93.55Zm0-178.76C46.57,8.34,8.34,46.57,8.34,93.55s38.22,85.21,85.21,85.21,85.21-38.22,85.21-85.21S140.54,8.34,93.55,8.34Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M79.17,96.67c8.94,0,15.85-7.03,15.85-15.85s-7.03-15.85-15.85-15.85-15.85,6.91-15.85,15.85,7.03,15.85,15.85,15.85Zm0-25.38c5.36,0,9.53,4.17,9.53,9.53s-4.17,9.53-9.53,9.53-9.53-4.17-9.53-9.53,4.17-9.53,9.53-9.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M79.17,99.88c-9.18,0-17.76,3.81-24.43,10.49-1.31,1.31-1.31,3.22,0,4.41s3.22,1.31,4.41,0c5.36-5.36,12.75-8.58,20.02-8.58s14.3,3.22,20.02,8.58c.6,.6,1.55,.95,2.26,.95,.95,0,1.55-.36,2.26-.95,1.31-1.31,1.31-3.22,0-4.41-6.79-6.67-15.61-10.49-24.55-10.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M110.99,96.67c5.36,0,9.53-4.17,9.53-9.53s-4.17-9.53-9.53-9.53-9.53,4.17-9.53,9.53,4.05,9.53,9.53,9.53Zm0-12.63c1.91,0,3.22,1.31,3.22,3.22s-1.31,3.22-3.22,3.22-3.22-1.31-3.22-3.22c0-2.03,1.31-3.22,3.22-3.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M129.1,107.15c-6.67-6.32-15.85-8.58-25.15-6.32-1.55,.36-2.86,2.26-2.26,3.81,.36,1.55,2.26,2.86,3.81,2.26,7.03-1.91,14.3,0,19.43,4.77,.6,.6,1.31,.95,2.26,.95s1.55-.36,2.26-.95c.83-1.31,.83-3.58-.36-4.53Z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPanelistas);
export default __webpack_public_path__ + "static/media/panelistas.2d155e16ce39bc3805f1c3567cd700ae.svg";
export { ForwardRef as ReactComponent };